// Small shared helpers for the public Places feature (PicksSection,
// EventsSection, PlacesListPage, PlaceDetailPage). The canonical URL
// builders live in shared/seo/paths.mjs — the ONE definition, also used by
// the server's canonical/og:url/sitemap output — re-exported here so
// existing call sites keep importing from "../utils/places".
import { placesListPath, placeDetailPath } from "../shared/seo/paths.mjs";

export { placesListPath, placeDetailPath };

export const citiesMatch = (a, b) =>
  (a || "").toLowerCase() === (b || "").toLowerCase();

// Vibe / "occasion" landing page, e.g. /places/southampton/mood/date-night.
// The literal "mood" segment keeps this 3-segment shape from colliding with
// the 2-segment /places/:city/:slug detail route (and its server mirror in
// server/utils/knownSpaRoutes.js). Client-only.
export const placeMoodPath = (city, vibe) =>
  `${placesListPath(city)}/mood/${encodeURIComponent(vibe)}`;
